import { withErrorBoundary } from 'react-error-boundary';
import { css } from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import type { ContentfulArticleGroupModel } from 'autogen/swagger/all';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import Layout from 'components/Layout';
import { addScrollPadding } from 'modules/helpers/mixins';
import { breakpoint } from 'variables';
import ArticleCardItem from './ArticleCardItem';
import SwimlaneHeader from './SwimlaneHeader';

const scrollContainerStyling = css`
    ${addScrollPadding()}
    margin-left: -${Spacing16};
    margin-right: -${Spacing16};

    ${breakpoint.up('1025px')} {
        ${addScrollPadding('0px')}
        margin: 0;
    }
`;

function ArticleCardSliderSection({ articleGroups }: { articleGroups: ContentfulArticleGroupModel[] }) {
    return articleGroups.map((articleGroup) => {
        const { articles, headline, sectionId, seeMoreLink } = articleGroup;
        if (!articles?.hits?.length) return null;

        return (
            <Layout.Section
                key={sectionId}
                headingRenderer={() => <SwimlaneHeader headline={headline} seeMoreLink={seeMoreLink} />}
            >
                <DynamicItemCarousel
                    gapSize={Spacing16}
                    items={articles.hits}
                    scrollContainerCss={scrollContainerStyling}
                    itemRenderer={(hit, index) => (
                        <ArticleCardItem article={hit} key={index} data-slide-index={index} />
                    )}
                />
            </Layout.Section>
        );
    });
}

export default withErrorBoundary(ArticleCardSliderSection, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
